import Swiper, { Navigation, Parallax } from 'swiper'
import 'swiper/modules/parallax/parallax.scss'

document.addEventListener('DOMContentLoaded', () => {
    const sliderWrappers = document.querySelectorAll('.mtt-info-slider')

    if (sliderWrappers.length > 0) {
        sliderWrappers.forEach(sliderWrapper => {
            const swiperElement = sliderWrapper.querySelector('.mtt-info-slider__swiper')
            const nextButton = sliderWrapper.querySelector('.swiper-next')
            const prevButton = sliderWrapper.querySelector('.swiper-prev')

            const swiperOptions = {
                modules: [ Navigation, Parallax ],
                speed: 500,
                spaceBetween: 8,
                slidesPerView: 1,
                threshold: 8,
                loop: false,
                parallax: true,
                grabCursor: true,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton
                },
                breakpoints: {
                    400: {
                        spaceBetween: 16,
                        slidesPerView: 1.25
                    },
                    500: {
                        spaceBetween: 16,
                        slidesPerView: 1.5
                    },
                    580: {
                        spaceBetween: 16,
                        slidesPerView: 2
                    },
                    800: {
                        spaceBetween: 24,
                        slidesPerView: 1
                    },
                    1000: {
                        spaceBetween: 24,
                        slidesPerView: 2
                    }
                }
            }

            const swiper = new Swiper(swiperElement, swiperOptions)
        })
    }
})
